import * as React from 'react'

import { cn } from '@/lib/utils'

/*
 * Atalhos de teclado do começo da página ("Ir para o conteúdo"). Ficam fora da
 * tela e descem para o canto superior esquerdo ao receber foco, acima de tudo
 * (`--gef-camada-atalho`), no verde de ação. A tecla de acesso, quando há,
 * aparece numa etiqueta ao lado do texto.
 */
function SkipLink({ className, ...props }: React.ComponentProps<'nav'>) {
  return (
    <nav
      data-slot="skip-link"
      aria-label="Atalhos de teclado"
      className={cn('fixed top-0 left-4 z-(--gef-camada-atalho) flex flex-col', className)}
      {...props}
    />
  )
}

function SkipLinkItem({ className, accessKey, children, ...props }: React.ComponentProps<'a'>) {
  return (
    <a
      data-slot="skip-link-item"
      accessKey={accessKey}
      className={cn(
        'absolute top-0 left-0 inline-flex -translate-y-[200%] items-center gap-3 whitespace-nowrap',
        'rounded-b-lg bg-primary px-4 py-3 text-md font-bold text-primary-foreground shadow-lg',
        'transition-transform duration-(--gef-duracao-rapida) focus:translate-y-0',
        // Sobre o verde, o contorno de foco é branco e fica por dentro.
        '[--gef-foco:var(--gef-texto-inverso)] focus-visible:-outline-offset-4',
        className
      )}
      {...props}
    >
      {children}
      {accessKey !== undefined && (
        <span
          aria-hidden="true"
          className="rounded-sm bg-primary-foreground px-2 text-xs text-primary"
        >
          {accessKey}
        </span>
      )}
    </a>
  )
}

export { SkipLink, SkipLinkItem }
